/**
 * Logorithmic Grouping Layout
 * Extends from the Linear Grouping Layout. Essentially the same, but
 * with special rules for logorithmic scales.
 */

import GroupsLinear from './groups-linear'
import { scaleLog } from 'd3-scale'
import { extent } from 'd3-array'

export default class GroupsLog extends GroupsLinear {
  static defaults = {
    ...GroupsLinear.defaults,
    logBase: 2
  }

  canDisplayLogorithmically() {
    return Math.min(...this.domainY) >= 0
  }

  getScaleY() {
    if (this.canDisplayLogorithmically() === false) {
      return super.getScaleY()
    }

    const scale = scaleLog()

    scale.base(this.logBase)
    scale.domain(extent(this.domainY))
    scale.nice(4)

    return scale
  }
}



// WEBPACK FOOTER //
// /home/runner/work/web-interactive/web-interactive/lib/components/charts/layouts/groups-log.js